import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ToastService } from "./toast.service";
import { Router, NavigationEnd } from "@angular/router";
import { Observable } from "rxjs";

@Injectable()
export class OfferPlanningService {
  private base_url = `${environment.API_URL}/plannings`;
  //private base_url = this.router.url;
  private token = localStorage.getItem("token");
  private headers = new HttpHeaders().set("Authorization", `${this.token}`);

  constructor(
    private http: HttpClient,
    private toast: ToastService,
    private router: Router
  ) {}

  getOffers(departure_id: number, arrival_id: number) {
    return this.http
      .post(
        this.base_url + "/offers",
        {
          departure_id: departure_id,
          arrival_id: arrival_id,
        },
        { headers: this.headers }
      )
      .map((res: any[]) => res);
  }

  getOffersWithRating(departure_id: number, arrival_id: number): Observable<any> {
    
    return this.http.post<any>(`${environment.API_URL}/offers/rating`, { departure_id: departure_id, arrival_id: arrival_id }, { headers: this.headers });
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/offer-planning.service.ts